import React, { useState } from "react";
import config from "../../Config";
import axios from "axios";
import StudentMenu from "./StudentMenu";
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RightsCheck from "../General/RightsCheck";

const DEFAULT_PASSWORD_NOTE = "12345678";

function StudentProfileSearch() {
  document.title = "Student Profile";

  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [StudentID, setStudentID] = useState("");

  const [resetInput, setResetInput] = useState("");
  const [resetStudent, setResetStudent] = useState(null);
  const [resetSearchLoading, setResetSearchLoading] = useState(false);
  const [resetSubmitLoading, setResetSubmitLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const v = String(StudentID || "").trim();
    if (!v) {
      toast.error("Enter student ID or registration number.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    window.open(`/students/PrintStudentProfile?StudentCode=${encodeURIComponent(v)}`, "_blank", "noopener,noreferrer");
  };

  const handleSearchForReset = (e) => {
    e.preventDefault();
    const q = String(resetInput || "").trim();
    if (!q) {
      toast.error("Enter student ID or registration number.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    setResetSearchLoading(true);
    setResetStudent(null);
    axios({
      method: "post",
      url: config.base_url + "Student/SearchStudentForPasswordReset",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        Registration_No: q,
      },
    })
      .then((res) => {
        if (res.data.status_code === 1 && res.data.Student) {
          setResetStudent(res.data.Student);
          toast.success(res.data.status_message || "Student found.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          setResetStudent(null);
          toast.error(res.data.status_message || "No student found.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        setResetStudent(null);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setResetSearchLoading(false));
  };

  const handleResetPassword = () => {
    if (!resetStudent?.Student_ID) {
      toast.error("Search for a student first.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    if (
      !window.confirm(
        `Reset login password for ${resetStudent.Student_Name || "this student"} (ID ${resetStudent.Student_ID}) to default ${DEFAULT_PASSWORD_NOTE}?`
      )
    ) {
      return;
    }
    setResetSubmitLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Student/ResetStudentPasswordAdmin",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        Student_ID: resetStudent.Student_ID,
      },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          toast.success(res.data.status_message || "Password reset.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setResetStudent(null);
          setResetInput("");
        } else {
          toast.error(res.data.status_message || "Reset failed.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setResetSubmitLoading(false));
  };

  return (
    <>
      <RightsCheck />
      <StudentMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/students/StudentDashboard">Students</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Student Profile
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Student Profile</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="card mb-4">
                  <div className="card-body card-form-wrap">
                    <div className="form-wrap">
                      <div className="form-legend">Step 1. Search student (print profile)</div>
                      <form onSubmit={handleSubmit} className="row g-2 align-items-end">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                          Enter student ID or registration no.
                        </label>
                        <div className="col-md-5">
                          <input
                            type="text"
                            name="Student_ID"
                            value={StudentID}
                            onChange={(e) => setStudentID(e.target.value)}
                            className="form-control"
                            placeholder="e.g. 4567"
                          />
                        </div>
                        <div className="col-md-4">
                          <button type="submit" className="button button-primary w-100">
                            Open print profile
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body card-form-wrap">
                    <div className="form-wrap">
                      <div className="form-legend">Reset student password</div>
                      <p className="small text-muted mb-3">
                        Search by <strong>student ID</strong> or <strong>registration number</strong>. After you confirm
                        the student, reset sets the student login password to <strong>{DEFAULT_PASSWORD_NOTE}</strong>{" "}
                        (stored as plain text, per school policy). A row is written to{" "}
                        <strong>student basic info history</strong> with your user name and a remark so audits can see
                        who performed the reset.
                      </p>
                      <form onSubmit={handleSearchForReset} className="row g-2 align-items-end mb-3">
                        <label className="col-md-3 col-form-label col-form-label-sm">
                          Student ID or registration no.
                        </label>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control"
                            value={resetInput}
                            onChange={(e) => setResetInput(e.target.value)}
                            placeholder="Enter ID or registration number"
                          />
                        </div>
                        <div className="col-md-4">
                          <button type="submit" className="button button-primary w-100" disabled={resetSearchLoading}>
                            {resetSearchLoading ? "Searching…" : "Search"}
                          </button>
                        </div>
                      </form>

                      {resetStudent && (
                        <div className="border rounded p-3 mb-3 bg-light">
                          <h6 className="mb-3">Confirm student</h6>
                          <table className="table table-sm table-borderless mb-0">
                            <tbody>
                              <tr>
                                <td className="text-muted" style={{ width: "160px" }}>
                                  Student ID
                                </td>
                                <td>{resetStudent.Student_ID}</td>
                              </tr>
                              <tr>
                                <td className="text-muted">Registration no.</td>
                                <td>{resetStudent.Registration_No}</td>
                              </tr>
                              <tr>
                                <td className="text-muted">Name</td>
                                <td>{resetStudent.Student_Name}</td>
                              </tr>
                              <tr>
                                <td className="text-muted">Father</td>
                                <td>{resetStudent.Father_Name}</td>
                              </tr>
                              <tr>
                                <td className="text-muted">Class</td>
                                <td>{resetStudent?.SelectedClass?.Class_Name ?? "—"}</td>
                              </tr>
                              <tr>
                                <td className="text-muted">Section</td>
                                <td>{resetStudent?.SelectedSection?.Section_Name ?? "—"}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="mt-3">
                            <button
                              type="button"
                              className="button button-primary"
                              onClick={handleResetPassword}
                              disabled={resetSubmitLoading}
                            >
                              {resetSubmitLoading ? "Resetting…" : `Reset password to ${DEFAULT_PASSWORD_NOTE}`}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentProfileSearch;
